<template>
    <div class="question-list p-4">
        <!-- Overlay caricamento -->
        <div v-if="isCountdownLoading" class="loading-overlay">
            <div class="spinner-border text-primary"></div>
            <div class="loading-text">Caricamento countdown...</div>
        </div>
        <div class="card mb-3 shadow-sm">
            <div class="card-body d-flex align-items-center justify-content-between">
                <h5 class="mb-3">
                    <!-- Tutti i quesiti ({{ countdownQuestions.length || 0 }}) -->
                    Tutti i quesiti ({{ countdownGroups.reduce((s, g) => s + g.questions.length, 0) }})
                </h5>
            </div>
        </div>

        <div class="countdown-view">
            <div class="countdown-column" v-for="(group, index) in countdownGroups" :key="index">
                <h6>{{ group.title }} ({{ group.questions.length }})</h6>

                <div class="questions-wrapper" :style="getWrapperStyle(group.questions.length)">
                    <div v-for="q in group.questions" :key="q.id" class="question-card"
                        @click="openQuestionDetail(q.id)">
                        <div class="d-flex justify-content-between align-items-center mb-1">
                            <strong class="me-2">{{ q.object }}</strong>
                            <div class="avatar-circle" :class="{ empty: !q.initials || q.initials === '--' }">
                                {{ q.initials || '-' }}
                            </div>
                        </div>

                        <div class="text-muted small mb-1">
                            #{{ q.id }} – {{ q.organization }}
                        </div>

                        <div class="text-muted small d-flex align-items-center mb-2">
                            <i class="bi bi-clock me-1"></i> {{ formatDate(q.expires_on) }}
                        </div>

                        <span class="status-box" :class="'status-' + q.state.color">
                            {{ q.state.label }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'QuestionsCountDownView',

    data() {
        return {
            isCountdownLoading: true,
            countdownQuestions: [],
            countdownSettings: {
                default_expiration_days: 15,
                third_column_days: 3,
                fourth_column_days: 1,
            }
        };
    },

    computed: {
        countdownGroups() {
            if (this.isCountdownLoading) return [];

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const col1Date = new Date(today);
            col1Date.setDate(today.getDate() + this.countdownSettings.fourth_column_days);

            const col3Date = new Date(today);
            col3Date.setDate(today.getDate() + this.countdownSettings.third_column_days);

            const sortDesc = (arr) =>
                arr.slice().sort((a, b) => new Date(b.expires_on) - new Date(a.expires_on));

            const scaduti = [];
            const oneDay = [];
            const threeDaysGroup = [];
            const nonPrioritario = [];

            const getExpireDate = (q) => {
                if (!q.expires_on) return null;
                const d = new Date(q.expires_on);
                d.setHours(0, 0, 0, 0);
                return d;
            };

            this.countdownQuestions.forEach(q => {
                const exp = getExpireDate(q);

                if (!exp) {
                    //nonPrioritario.push(q);
                    return;
                }

                if (exp <= today) {
                    scaduti.push(q);
                }
                else if (exp.getTime() === col1Date.getTime()) {
                    oneDay.push(q);
                }
                else if (exp.getTime() === col3Date.getTime()) {
                    threeDaysGroup.push(q);
                }
                else {
                    nonPrioritario.push(q);
                }
            });

            return [
                { title: 'NON PRIORITARIO', questions: sortDesc(nonPrioritario) },
                { title: 'SCADUTI', questions: sortDesc(scaduti) },
                {
                    title: `IN SCADENZA TRA ${this.countdownSettings.fourth_column_days} GIORNO/I`,
                    questions: sortDesc(oneDay)
                },
                {
                    title: `IN SCADENZA TRA ${this.countdownSettings.third_column_days} GIORNO/I`,
                    questions: sortDesc(threeDaysGroup)
                }
            ];
        }
    },

    methods: {
        async loadCountdownSettings() {
            try {
                const response = await this.$root.$api.get('/questions/countdown-settings');
                if (response.data.settings) {
                    this.countdownSettings = response.data.settings;
                }
            } catch (error) {
                console.error('Errore caricamento impostazioni countdown', error);
            }
        },

        async loadCountdownQuestions() {
            this.isCountdownLoading = true;
            try {
                const response = await this.$root.$api.get('/questions/countdown');

                this.countdownQuestions = response.data.data.map(q => {
                    // Se expires_on esiste nel DB lo usiamo, altrimenti calcoliamo da created_at
                    /**const expires = q.expires_on ? new Date(q.expires_on) : (() => {
                        const d = new Date(q.created_at);
                        d.setDate(d.getDate() + this.countdownSettings.default_expiration_days);
                        return d;
                    })();*/

                    return {
                        ...q,
                        initials: q.initials || '-',
                        organization: q.organization || '—',
                        state: this.formatState(q.state_id),
                        expires_on: q.expires_on ? new Date(q.expires_on) : null
                    };
                });
            } finally {
                this.isCountdownLoading = false;
            }
        },

        formatState(state) {
            const map = {
                INVIATO: { label: 'RICEVUTO', color: 'yellow' },
                ASSEGNATO: { label: 'ASSEGNATO', color: 'blue' },
                IN_LAVORAZIONE: { label: 'IN LAVORAZIONE', color: 'purple' }
            };
            return map[state] || { label: state, color: 'gray' };
        },

        getWrapperStyle() {
            return { maxHeight: '48rem', overflowY: 'auto' };
        },

        formatDate(date) {
            return new Date(date).toLocaleString('it-IT');
        },

        openQuestionDetail(id) {
            this.$emit('change-view', 'QuestionDetailExpertView', id);
        }
    },

    async mounted() {
        await this.loadCountdownSettings();
        await this.loadCountdownQuestions();
    }
};
</script>

<style scoped>
.countdown-view {
    flex: 1;
    display: flex;
    gap: 1rem;
    padding: 1rem;
    height: 75vh;
}

.countdown-column {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0.5rem;
    background: #f8f9fa;
    border-radius: 0.25rem;
    height: 100%;
}

.questions-wrapper {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.countdown-column h6 {
    text-align: center;
    font-weight: bold;
    margin-bottom: 0.5rem;
}

.question-card {
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 0.5rem;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
    cursor: pointer;
    transition: all 0.2s;
}

.question-card:hover {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
}

.avatar-circle {
    width: 33px;
    height: 33px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    color: #6c757d;
    background: white;
    border: 2px solid gray;
}

.avatar-circle.empty {
    background: #fff;
    border-color: #6c757d;
    color: #6c757d;
}

.status-box {
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 0.75rem;
    color: white;
    font-weight: 600;
}

.status-yellow {
    background: #ffc107;
}

.status-blue {
    background: #0d6efd;
}

.status-purple {
    background: #6f42c1;
}

.status-gray {
    background: #6c757d;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}

.loading-text {
    margin-top: 1rem;
    font-weight: bold;
    color: #0d6efd;
}

.spinner-border-sm {
    width: 1rem;
    height: 1rem;
    border-width: 0.15em;
}

.avatar-circle {
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;

    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;

    background-color: #ffffff;
    border: 1px solid #ced4da;
    color: #000000;
    flex-shrink: 0;
}
</style>
